/**
 * ApiUser entity validation rules.
 * Backend requires UserPrincipalName to be a valid email (or @local).
 */

import { getEntityAttrString } from './ReusableValidation';
import type { ValidationWarning } from './ReusableValidation';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const LOCAL_SUFFIX = /@local$/i;

export function getApiUserWarnings(data: Record<string, any>): ValidationWarning[] {
    const warnings: ValidationWarning[] = [];

    const displayName = getEntityAttrString(data, 'DisplayName');
    if (!displayName) {
        warnings.push({
            message: 'Display Name should not be empty.',
            severity: 'warning',
            attributeDisplayNames: ['Display Name']
        });
    }

    const upn = getEntityAttrString(data, 'UserPrincipalName');
    if (!upn) {
        warnings.push({
            message: 'User Principal Name is required.',
            severity: 'warning',
            attributeDisplayNames: ['User Principal Name']
        });
    } else if (!EMAIL_REGEX.test(upn) && !LOCAL_SUFFIX.test(upn)) {
        warnings.push({
            message: 'User Principal Name should be a valid email address (e.g. user@domain.com).',
            severity: 'warning',
            attributeDisplayNames: ['User Principal Name']
        });
    }

    return warnings;
}
